import { apiDate, boolean, number, string, uuid, zodLess, ZodLessInfer } from '@kaiizen/zod-less';

import { ApiScanVideoAudioSchema } from './RecordTypes/ApiScanVideoSchema';

export const SCAN_VIDEO_AUDIO_CANONICAL_MIME = 'audio/wav';

export const ApiScanVideoAudioUploadInitItemSchema = zodLess({
  segmentId: uuid,
  mime: string,
  sizeBytes: number,
});
export type ApiScanVideoAudioUploadInitItem = ZodLessInfer<typeof ApiScanVideoAudioUploadInitItemSchema>;

export const ApiInitScanVideoAudioUploadSchema = zodLess({
  scanVideoId: uuid,
  uploads: [ApiScanVideoAudioUploadInitItemSchema],
});
export type ApiInitScanVideoAudioUpload = ZodLessInfer<typeof ApiInitScanVideoAudioUploadSchema>;

export const ApiScanVideoAudioUploadInitResponseItemSchema = zodLess({
  segmentId: uuid,
  objectKey: string,
  uploadUrl: string,
  expiresAt: apiDate,
});
export type ApiScanVideoAudioUploadInitResponseItem = ZodLessInfer<typeof ApiScanVideoAudioUploadInitResponseItemSchema>;

export const ApiInitScanVideoAudioUploadResponseSchema = zodLess({
  uploads: [ApiScanVideoAudioUploadInitResponseItemSchema],
});
export type ApiInitScanVideoAudioUploadResponse = ZodLessInfer<typeof ApiInitScanVideoAudioUploadResponseSchema>;

export const ApiCompleteScanVideoAudioUploadSegmentSchema = zodLess({
  segmentId: uuid,
  objectKey: string,
  sizeBytes: number,
  startSeconds: number,
  endSeconds: number,
  mime: string,
});
export type ApiCompleteScanVideoAudioUploadSegment = ZodLessInfer<typeof ApiCompleteScanVideoAudioUploadSegmentSchema>;

export const ApiCompleteScanVideoAudioUploadSchema = zodLess({
  scanVideoId: uuid,
  segments: [ApiCompleteScanVideoAudioUploadSegmentSchema],
});
export type ApiCompleteScanVideoAudioUpload = ZodLessInfer<typeof ApiCompleteScanVideoAudioUploadSchema>;

export const ApiCompleteScanVideoAudioUploadResponseSchema = zodLess({
  ok: boolean,
  scanVideoId: uuid,
  segments: [ApiScanVideoAudioSchema],
});
export type ApiCompleteScanVideoAudioUploadResponse = ZodLessInfer<typeof ApiCompleteScanVideoAudioUploadResponseSchema>;
